export const GET_USER_INFO_BY_ID = '/GetUserInfoByid';
export const GET_RECRUITS = 'recruit-info-query/GetRecruit';
export const GET_ROLES = 'recruit-info-query/GetAllRoles';
export const GET_STAGES = 'recruit-info-query/GetAllStages';
export const GET_RECRUITING_MANAGERS =
	'recruit-info-query/GetAllRecruitingManagers';
export const ADD_RECRUIT = 'recruit-info-cmd/AddRecruit';
export const GET_DASHBOARD_DETAILS = '/recruit-info-query/GetDashboardDetails';
export const GET_RECRUIT_DETAILS_BY_ID =
	'recruit-info-query/GetRecruitDetailsById';
export const ADD_UPDATE_RECRUIT_DETAILS =
	'recruit-info-cmd/AddUpdateRecruitDetails';
export const GET_OFFICE_TYPES = 'recruit-info-query/GetOfficeTypes';
export const GET_NOTES = '/notes-query/GetAllNotes';
export const ADD_OR_UPDATE_NOTES = '/notes-cmd/AddUpdateNote';
export const GET_ALL_RECRUIT_ITEMS = '/attachments-query/GetAllRecruitItems';
export const ADD_ATTACHMENT = '/attachments-cmd/UploadRecruitItem';
export const DELETE_ATTACHMENT = '/attachments-cmd/DeleteRecruitItem';
export const GET_DOWNLOAD_URL_BY_FIELD =
	'attachments-query/GetDownloadUrlByFileId';
export const GET_LOGGER_IN_MANAGER_ID =
	'recruit-info-query/GetLoggedInUserManagerId';
export const GET_ALL_STATES = '/recruit-info-query/GetAllStates';
export const GET_PAYMENT_TYPES = '/recruit-info-query/GetPaymentTypes';
export const GET_ALL_COMPANIES = '/recruit-info-query/GetAllCompanies';
export const GET_ALL_EXTERNAL_MANAGERS =
	'/recruit-info-query/GetAllExternalManagers';
export const GET_ALL_FIELDS = '/recruit-info-query/GetAllFields';
export const GET_FIELD_AUDIT_LOGS = '/recruit-info-query/GetFieldAuditLogs';
